// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoiceDialog .option-label{flex:6}`, "",{"version":3,"sources":["/app/src/components/orderSelectField/orderSelectField.scss"],"names":[],"mappings":"AAGE,6BACE,MAAA","sourcesContent":["@import 'src/assets/css/_colors.scss';\n\n.invoiceDialog {\n  .option-label {\n    flex: 6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
